import { MdArrowBack } from "react-icons/md";
import { CTA } from "@merchstores/shared/elements/Cta";
import { OrderStatus } from "@merchstores/admin/components/MerchStoreOrders";
import { getLocalDateText } from "@merchstores/admin/components/DateTime";
import { Role } from "@merchstores/admin/context/Roles";

import { IMerchStore } from "@merchstores/admin/components/MerchStore";
import { IMerchStoreOrder, ICombinedOrder } from "@merchstores/admin/components/MerchStoreOrders";

import { OrderDetailsSummary } from "./OrderDetailsSummary";

import { IOrderDetailsView } from "@merchstores/admin/components/MerchStoreOrdersView";

import "./OrderIndividualDetailsPage.scss";

export interface IOrderIndividualDetailsPageProps {
  merchStore: IMerchStore,
  combinedOrder: ICombinedOrder;
  order: IMerchStoreOrder;
  setSelectedOrderDetails(orderDetailsView: IOrderDetailsView): void;
  userRole: Role;
}

export const OrderIndividualDetailsPage: React.FC<IOrderIndividualDetailsPageProps> = (props: IOrderIndividualDetailsPageProps) => {
  const combinedOrder = props.combinedOrder;
  const merchStore = props.merchStore;
  const order = props.order;
  const setSelectedOrderDetails = props.setSelectedOrderDetails;
  const userRole = props.userRole;
  const shipToOffice = merchStore.shipToOffice;
  const officeAddress = merchStore.officeAddress;
  const closeDate = order.closedAt ? order.closedAt : merchStore.nextProcessingDate ? merchStore.nextProcessingDate : '';

  return (
    <div className="md:flex">
      <div className="order-details w-full md:p-30">
        <div className="p-20 md:p-0">
          <div className="w-full flex mb-3 lg:mb-3">
            <div className="flex">
              <CTA
                size="small"
                type="mobile-icon"
                onClick={() => {
                  setSelectedOrderDetails({
                    viewType: 'combined_order',
                    combinedOrder: combinedOrder,
                    individualOrder: null
                  })
                }}
              >
                <MdArrowBack />
              </CTA>
              <div className="ml-6 flex font-bold text-xl">{order.name}</div>
            </div>
          </div>

          <div className='md:flex w-full md:ml-60'>
            <div className='md:flex-grow mb-15'>
              <div className='section-title mb-10'>
                {order.customer ? order.customer.displayName : ''}
              </div>
              <div className='section-info'>
                {order.customer ? order.customer.email : ''}
              </div>
            </div>
            <div className='md:flex-grow mb-15'>
              <div className='section-title mb-10'>
                Shipping Address
              </div>
              <div className='section-info'>
                <div className='section-subtitle'>{shipToOffice ? 'Ship to Office' : ''}</div>
                {shipToOffice && officeAddress ? <>
                  <div>{officeAddress.address1} {officeAddress.address2}</div>
                  <div>{officeAddress.city} {officeAddress.state} {officeAddress.zip}</div>
                  <div>{officeAddress.country}</div>
                </>
                  :
                  order.shippingAddress && <>
                    <div>{order.shippingAddress.address1} {order.shippingAddress.address2}</div>
                    <div>{order.shippingAddress.city} {order.shippingAddress.state} {order.shippingAddress.zip}</div>
                    <div>{order.shippingAddress.country}</div>
                  </>
                }
              </div>
            </div>
            {order.status === OrderStatus.closed &&
              <div className='md:flex-grow'>
                <div className='section-title mb-10'>
                  Billing Address
                </div>
                <div className='section-info'>
                  <div className='section-subtitle'>{'Group Payment'}</div>
                  {order.billingAddress && <>
                    <div>{order.billingAddress.address1} {order.billingAddress.address2}</div>
                    <div>{order.billingAddress.city} {order.billingAddress.state} {order.billingAddress.zip}</div>
                    <div>{order.billingAddress.country}</div>
                  </>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        <div className="w-full mt-10">

        </div>
      </div>
      <OrderDetailsSummary
        order={order}
        userRole={userRole}
        closeDate={closeDate}
      />
    </div>
  )
}
